import { WithReservationId } from '@mews-commander/types';
import { Empty, LocalizedDateTimeFromUtc, OverlayedLoader, TooltippedIcon } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { IconName, Stack, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { useReservationNotesQuery } from '../hooks';
import { NoteItem } from './NoteItem';

export type ReservationNotesProps = WithReservationId;

export const ReservationNotes = ({ reservationId }: ReservationNotesProps) => {
    const { data: notes, isFetching } = useReservationNotesQuery({ reservationId });

    return (
        <Stack data-test-id={reservationId} vertical spacing="200">
            <Stack spacing="100" itemAlignment="center">
                <Typography textStyle="bodyMediumStrong" variant="primary" as="div">
                    {lt('Reservation')}
                </Typography>
                <TooltippedIcon
                    size="small"
                    value={IconName.Info}
                    tooltip={lt('GuestInHouseReportReservationNotesTooltip')}
                />
            </Stack>
            <Stack spacing="200" vertical>
                <OverlayedLoader show={isFetching} />
                {!notes.length ? (
                    <Empty textAlign="left" />
                ) : (
                    notes.map((note) => (
                        <NoteItem
                            key={note.id}
                            text={note.text}
                            footer={
                                <>
                                    {note.createdUtc === note.updatedUtc ? lt('CreatedOn') : lt('UpdatedOn')}
                                    {UnicodeEntity.NoBreakSpace}
                                    <LocalizedDateTimeFromUtc
                                        utcString={
                                            note.createdUtc === note.updatedUtc ? note.createdUtc : note.updatedUtc
                                        }
                                    />
                                </>
                            }
                        />
                    ))
                )}
            </Stack>
        </Stack>
    );
};
